
export default function ServiceAreaSection() {
  const serviceAreas = [
    { name: 'Waterloo Region', cities: ['Kitchener', 'Waterloo', 'Cambridge', 'Guelph'] },
    { name: 'Brant County', cities: ['Brantford', 'Paris', 'Burford', 'Mount Pleasant'] },
    { name: 'Wellington County', cities: ['Fergus', 'Elora', 'Arthur', 'Mount Forest'] }
  ];
  
  return (
    <section className="py-20 bg-dark-800">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
                Proudly Serving <span className="text-red-400">Southern Ontario</span>
              </h2>
              <p className="text-xl text-gray-300 leading-relaxed mb-8">
                Licensed across Ontario with deep local expertise in Waterloo, Brant County, 
                and Wellington County. Wherever you are in the province, I'm here to help.
              </p>
            </div>
            
            <div className="grid sm:grid-cols-3 gap-6">
              {serviceAreas.map((area, index) => (
                <div key={index} className="bg-dark-900 rounded-xl p-6 shadow-md border border-dark-700">
                  <h3 className="font-bold text-lg text-white mb-3">{area.name}</h3>
                  <ul className="space-y-1">
                    {area.cities.map((city, cityIndex) => (
                      <li key={cityIndex} className="text-gray-300 text-sm flex items-center">
                        <i className="ri-map-pin-fill text-red-400 mr-2 w-3 h-3 flex items-center justify-center text-xs"></i>
                        {city}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            
            <div className="bg-red-600 text-white rounded-xl p-6">
              <div className="flex items-center space-x-3 mb-2">
                <i className="ri-shield-check-line text-2xl"></i>
                <h3 className="font-bold text-lg">Ontario Licensed</h3>
              </div>
              <p className="text-red-100">
                Fully licensed to serve clients across all of Ontario. 
                Distance is never a barrier to exceptional service.
              </p>
            </div>
          </div>
          
          {/* Visual */}
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/affbd59f821a8490e5bdea79e1e09b6e.jpg"
              alt="Service Areas"
              className="w-full h-96 object-cover object-top rounded-2xl shadow-xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-dark-900/70 to-transparent rounded-2xl"></div>
            <div className="absolute bottom-6 left-6 text-white">
              <div className="text-2xl font-bold">25+ Years</div>
              <div className="text-sm opacity-90">Serving Ontario Families</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
